const ua = typeof window !== 'undefined' ? window.navigator.userAgent : '';
//
const isWebKit = ua.includes("AppleWebKit");
const isSafari = ua.includes("Safari");
const isVersion = ua.includes("Version");
const isWKWebView = isWebKit && !isSafari && !isVersion;
//
const isEyeJackApp = ua.includes('EyeJack');
const isBabylonNative = ua.includes('BabylonNative');
//
export const IS_EYEJACK_APP = isEyeJackApp;
export const IS_EYEJACK_WEBXR_POLYFILL = isEyeJackApp && !isBabylonNative && isWKWebView;
export const IS_BABYLON_NATIVE = isEyeJackApp && isBabylonNative;
export const IS_BABYLON_NATIVE_WEBVIEW = isEyeJackApp && isBabylonNative && isWKWebView;
export const IS_BABYLON_NATIVE_JSCORE = isEyeJackApp && isBabylonNative && !isWKWebView;
/**
 * @deprecated EJApp is deprecated, use IS_EYEJACK_APP instead.
 */
export const EJApp = IS_EYEJACK_APP;

export default class Utils {
  /**
   * Generate a full UUID (36 chars)
   * e.g., "550e8400-e29b-41d4-a716-446655440000"
   */
  static UUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /**
   * Generate a short UUID (16 chars)
   * e.g., "a1b2c3d4e5f67890"
   */
  static UUIDShort() {
    return 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
      const r = Math.random() * 16 | 0;
      return r.toString(16);
    });
  }
}
